/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateAppSellerApplicationRequest,
    CreateAppSellerApplicationRequestV2,
    CreateAppSellerApplicationRequestV3,
    EditAppSellerApplicationRequest,
    PatchAppSellerApplicationRequest,
    UpdateAppSellerApplicationStatusBody,
    ValidateSellerCodeResponse,
} from '../models';

export interface AppSellerApplicationApiControllerApproveAppSellerApplicationRequest {
    applicationId: string;
    updateAppSellerApplicationStatusBody: UpdateAppSellerApplicationStatusBody;
}

export interface AppSellerApplicationApiControllerCreateRequest {
    createAppSellerApplicationRequest: CreateAppSellerApplicationRequest;
}

export interface AppSellerApplicationApiControllerCreateV2Request {
    createAppSellerApplicationRequestV2: CreateAppSellerApplicationRequestV2;
}

export interface AppSellerApplicationApiControllerCreateV3Request {
    createAppSellerApplicationRequestV3: CreateAppSellerApplicationRequestV3;
}

export interface AppSellerApplicationApiControllerDeleteSubmittedApplicationRequest {
    applicationId: string;
}

export interface AppSellerApplicationApiControllerEditAppSellerApplicationRequest {
    applicationId: string;
    editAppSellerApplicationRequest: EditAppSellerApplicationRequest;
}

export interface AppSellerApplicationApiControllerPatchAppSellerApplicationRequest {
    applicationId: string;
    patchAppSellerApplicationRequest: PatchAppSellerApplicationRequest;
}

export interface AppSellerApplicationApiControllerRejectAppSellerApplicationRequest {
    applicationId: string;
    updateAppSellerApplicationStatusBody: UpdateAppSellerApplicationStatusBody;
}

export interface AppSellerApplicationApiControllerValidateSellerCodeRequest {
    sellerCode: string;
}

/**
 * 
 */
export class AppSellerApplicationApi extends runtime.BaseAPI {

    /**
     */
    async appSellerApplicationApiControllerApproveAppSellerApplicationRaw(requestParameters: AppSellerApplicationApiControllerApproveAppSellerApplicationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.applicationId === null || requestParameters.applicationId === undefined) {
            throw new runtime.RequiredError('applicationId','Required parameter requestParameters.applicationId was null or undefined when calling appSellerApplicationApiControllerApproveAppSellerApplication.');
        }

        if (requestParameters.updateAppSellerApplicationStatusBody === null || requestParameters.updateAppSellerApplicationStatusBody === undefined) {
            throw new runtime.RequiredError('updateAppSellerApplicationStatusBody','Required parameter requestParameters.updateAppSellerApplicationStatusBody was null or undefined when calling appSellerApplicationApiControllerApproveAppSellerApplication.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/app-seller-applications/{applicationId}:approve`.replace(`{${"applicationId"}}`, encodeURIComponent(String(requestParameters.applicationId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateAppSellerApplicationStatusBody,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async appSellerApplicationApiControllerApproveAppSellerApplication(requestParameters: AppSellerApplicationApiControllerApproveAppSellerApplicationRequest): Promise<void> {
        await this.appSellerApplicationApiControllerApproveAppSellerApplicationRaw(requestParameters);
    }

    /**
     */
    async appSellerApplicationApiControllerCreateRaw(requestParameters: AppSellerApplicationApiControllerCreateRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.createAppSellerApplicationRequest === null || requestParameters.createAppSellerApplicationRequest === undefined) {
            throw new runtime.RequiredError('createAppSellerApplicationRequest','Required parameter requestParameters.createAppSellerApplicationRequest was null or undefined when calling appSellerApplicationApiControllerCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/app-seller-applications`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createAppSellerApplicationRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async appSellerApplicationApiControllerCreate(requestParameters: AppSellerApplicationApiControllerCreateRequest): Promise<void> {
        await this.appSellerApplicationApiControllerCreateRaw(requestParameters);
    }

    /**
     */
    async appSellerApplicationApiControllerCreateV2Raw(requestParameters: AppSellerApplicationApiControllerCreateV2Request): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.createAppSellerApplicationRequestV2 === null || requestParameters.createAppSellerApplicationRequestV2 === undefined) {
            throw new runtime.RequiredError('createAppSellerApplicationRequestV2','Required parameter requestParameters.createAppSellerApplicationRequestV2 was null or undefined when calling appSellerApplicationApiControllerCreateV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/app-seller-applications`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createAppSellerApplicationRequestV2,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async appSellerApplicationApiControllerCreateV2(requestParameters: AppSellerApplicationApiControllerCreateV2Request): Promise<void> {
        await this.appSellerApplicationApiControllerCreateV2Raw(requestParameters);
    }

    /**
     */
    async appSellerApplicationApiControllerCreateV3Raw(requestParameters: AppSellerApplicationApiControllerCreateV3Request): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.createAppSellerApplicationRequestV3 === null || requestParameters.createAppSellerApplicationRequestV3 === undefined) {
            throw new runtime.RequiredError('createAppSellerApplicationRequestV3','Required parameter requestParameters.createAppSellerApplicationRequestV3 was null or undefined when calling appSellerApplicationApiControllerCreateV3.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v3/app-seller-applications`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createAppSellerApplicationRequestV3,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async appSellerApplicationApiControllerCreateV3(requestParameters: AppSellerApplicationApiControllerCreateV3Request): Promise<void> {
        await this.appSellerApplicationApiControllerCreateV3Raw(requestParameters);
    }

    /**
     */
    async appSellerApplicationApiControllerDeleteSubmittedApplicationRaw(requestParameters: AppSellerApplicationApiControllerDeleteSubmittedApplicationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.applicationId === null || requestParameters.applicationId === undefined) {
            throw new runtime.RequiredError('applicationId','Required parameter requestParameters.applicationId was null or undefined when calling appSellerApplicationApiControllerDeleteSubmittedApplication.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/app-seller-applications/{applicationId}`.replace(`{${"applicationId"}}`, encodeURIComponent(String(requestParameters.applicationId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async appSellerApplicationApiControllerDeleteSubmittedApplication(requestParameters: AppSellerApplicationApiControllerDeleteSubmittedApplicationRequest): Promise<void> {
        await this.appSellerApplicationApiControllerDeleteSubmittedApplicationRaw(requestParameters);
    }

    /**
     * Public API
     */
    async appSellerApplicationApiControllerEditAppSellerApplicationRaw(requestParameters: AppSellerApplicationApiControllerEditAppSellerApplicationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.applicationId === null || requestParameters.applicationId === undefined) {
            throw new runtime.RequiredError('applicationId','Required parameter requestParameters.applicationId was null or undefined when calling appSellerApplicationApiControllerEditAppSellerApplication.');
        }

        if (requestParameters.editAppSellerApplicationRequest === null || requestParameters.editAppSellerApplicationRequest === undefined) {
            throw new runtime.RequiredError('editAppSellerApplicationRequest','Required parameter requestParameters.editAppSellerApplicationRequest was null or undefined when calling appSellerApplicationApiControllerEditAppSellerApplication.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/app-seller-applications/{applicationId}`.replace(`{${"applicationId"}}`, encodeURIComponent(String(requestParameters.applicationId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.editAppSellerApplicationRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Public API
     */
    async appSellerApplicationApiControllerEditAppSellerApplication(requestParameters: AppSellerApplicationApiControllerEditAppSellerApplicationRequest): Promise<void> {
        await this.appSellerApplicationApiControllerEditAppSellerApplicationRaw(requestParameters);
    }

    /**
     */
    async appSellerApplicationApiControllerPatchAppSellerApplicationRaw(requestParameters: AppSellerApplicationApiControllerPatchAppSellerApplicationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.applicationId === null || requestParameters.applicationId === undefined) {
            throw new runtime.RequiredError('applicationId','Required parameter requestParameters.applicationId was null or undefined when calling appSellerApplicationApiControllerPatchAppSellerApplication.');
        }

        if (requestParameters.patchAppSellerApplicationRequest === null || requestParameters.patchAppSellerApplicationRequest === undefined) {
            throw new runtime.RequiredError('patchAppSellerApplicationRequest','Required parameter requestParameters.patchAppSellerApplicationRequest was null or undefined when calling appSellerApplicationApiControllerPatchAppSellerApplication.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/app-seller-applications/{applicationId}`.replace(`{${"applicationId"}}`, encodeURIComponent(String(requestParameters.applicationId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchAppSellerApplicationRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async appSellerApplicationApiControllerPatchAppSellerApplication(requestParameters: AppSellerApplicationApiControllerPatchAppSellerApplicationRequest): Promise<void> {
        await this.appSellerApplicationApiControllerPatchAppSellerApplicationRaw(requestParameters);
    }

    /**
     */
    async appSellerApplicationApiControllerRejectAppSellerApplicationRaw(requestParameters: AppSellerApplicationApiControllerRejectAppSellerApplicationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.applicationId === null || requestParameters.applicationId === undefined) {
            throw new runtime.RequiredError('applicationId','Required parameter requestParameters.applicationId was null or undefined when calling appSellerApplicationApiControllerRejectAppSellerApplication.');
        }

        if (requestParameters.updateAppSellerApplicationStatusBody === null || requestParameters.updateAppSellerApplicationStatusBody === undefined) {
            throw new runtime.RequiredError('updateAppSellerApplicationStatusBody','Required parameter requestParameters.updateAppSellerApplicationStatusBody was null or undefined when calling appSellerApplicationApiControllerRejectAppSellerApplication.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/app-seller-applications/{applicationId}:reject`.replace(`{${"applicationId"}}`, encodeURIComponent(String(requestParameters.applicationId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateAppSellerApplicationStatusBody,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async appSellerApplicationApiControllerRejectAppSellerApplication(requestParameters: AppSellerApplicationApiControllerRejectAppSellerApplicationRequest): Promise<void> {
        await this.appSellerApplicationApiControllerRejectAppSellerApplicationRaw(requestParameters);
    }

    /**
     */
    async appSellerApplicationApiControllerValidateSellerCodeRaw(requestParameters: AppSellerApplicationApiControllerValidateSellerCodeRequest): Promise<runtime.ApiResponse<ValidateSellerCodeResponse>> {
        if (requestParameters.sellerCode === null || requestParameters.sellerCode === undefined) {
            throw new runtime.RequiredError('sellerCode','Required parameter requestParameters.sellerCode was null or undefined when calling appSellerApplicationApiControllerValidateSellerCode.');
        }

        const queryParameters: any = {};

        if (requestParameters.sellerCode !== undefined) {
            queryParameters['sellerCode'] = requestParameters.sellerCode;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/app-seller-applications:validateSellerCode`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async appSellerApplicationApiControllerValidateSellerCode(requestParameters: AppSellerApplicationApiControllerValidateSellerCodeRequest): Promise<ValidateSellerCodeResponse> {
        const response = await this.appSellerApplicationApiControllerValidateSellerCodeRaw(requestParameters);
        return await response.value();
    }

}
